module.exports = __webpack_public_path__ + "media/images/signups/card/card-ordered-success-c552c88c35d034749ac2ddbbb350d4f4.png";